var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "공용작업실",
            "tabActive": "신설동 스케쥴",
            "bg": "/images/sub/sub-visual5.jpg"
          },
          scopedSlots: _vm._u([{
            key: "tit",
            fn: function () {
              return [_vm._v("공용작업실")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("신설동 스케쥴")];
      },
      proxy: true
    }])
  }, [_c('v-divider', {
    staticClass: "grey darken4",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('div', {
    staticClass: "pa-12px px-md-20px py-md-16px"
  }, [_c('tit-primary', {
    attrs: {
      "titSize": "tit--sm"
    }
  }, [_vm._v(" " + _vm._s(_vm.$dayjs(this.$route.query.date).format("YYYY년 MM월 DD일")) + " ")])], 1), _c('table-tertiary', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th-primary', {
          staticStyle: {
            "width": "34%"
          }
        }, [_vm._v("업체명")]), _c('th-primary', {
          staticStyle: {
            "width": "34%"
          }
        }, [_vm._v("사용기기")]), _c('th-primary', {
          staticStyle: {
            "width": "32%"
          }
        }, [_vm._v("수량")])], 1)])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function () {
        return [_c('tbody', _vm._l(_vm.schedules, function (schedule, index) {
          return _c('tr', {
            key: index
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(schedule.company))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(schedule.equipment))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(schedule.quantity))])]);
        }), 0)];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "btn-wrap btn-wrap--sm"
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('btn-secondary2', {
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_vm._v("리스트")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }